import React, { createContext, useContext } from 'react';

const ADMIN_MODE = { isAdminMode: true };
const CRM_MODE = { isAdminMode: false };

const AdminModeContext = createContext(CRM_MODE);

/**
 * Wraps the page layout, so everything rendered under it (including the side and top nav)
 * is in admin mode while on an /admin route.
 */
export const AdminModeProvider = ({ isAdminMode, children }) => (
	<AdminModeContext.Provider value={isAdminMode ? ADMIN_MODE : CRM_MODE}>
		{children}
	</AdminModeContext.Provider>
);

export const useAdminModeContext = () => useContext(AdminModeContext);
